import { Component } from '../../../../../utils'

@Component({
    template: require('./skCircleLoader.tpl.html'),
    styles: require('./_skCircleLoader.scss')
})
export default class skCircleLoader {
}



// WEBPACK FOOTER //
// ./src/app/common/components/loaders/skCircleLoader/skCircleLoader.js